import { render, staticRenderFns } from "./goods-detail.vue?vue&type=template&id=4b239d36&scoped=true&"
import script from "./goods-detail.vue?vue&type=script&lang=js&"
export * from "./goods-detail.vue?vue&type=script&lang=js&"
import style0 from "./goods-detail.vue?vue&type=style&index=0&id=4b239d36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b239d36",
  null
  
)

export default component.exports